import { BrandConfig } from '../types';

export const estrelabetConfig: BrandConfig = {
  id: 'estrelabet',
  name: 'Jogo Global Certified Games',
  displayName: 'Jogo Global Certified Games',
  logo: 'JG-logo.png',
  primaryColor: '#f5a623',
  categories: [
    {
      name: 'Jogo Global Certified Games',
      banner: 'banners/banner_JG.png',
      gamesPath: 'estrelabet/jogoGames/estrelabet-cert.json',
      brandIcon: '',
      comingSoon: false,
      disabled: false
    }
  ],
  defaultBanners: []
};
